// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"41152a9578d70f63","6473":"bf70e2877bce7a20"}[chunkId] + ".css";
};